import { Dimensions } from "react-native";

const motherProfile = require("./assets/mom.png");
const fatherProfile = require("./assets/dad.png");
const kidsWithDoctor = require("./assets/kids-with-doctor.png");

export { motherProfile, fatherProfile, kidsWithDoctor };

const happyPencil = require("./assets/happy-pencil.png");
const question = require("./assets/question.png");
const lightBulb = require("./assets/bulb.png");
const questionPencil = require("./assets/question-pencil.png");
const happyKidsJumping = require("./assets/happy-kids-jumping.jpg");

export { happyPencil, question, lightBulb, questionPencil, happyKidsJumping };

const consultationDoctor = require("./assets/consultation.png");
const doctorAvatar = require("./assets/doctor-avatar.png");
const babyBoy = require("./assets/baby-boy.png");
const babyGirl = require("./assets/baby-girl.png");

export { consultationDoctor, doctorAvatar, babyBoy, babyGirl };

const tutorial = require("./assets/Tutorial.jpg");

export { tutorial };

const noMoney = require("./assets/no-money.png");

export { noMoney };

const tests = require("./assets/Tests.png");
export { tests };

const newChild = require("./assets/new-child.png");
export { newChild };

const testChildren = require("./assets/do-test.png");
export { testChildren };

const consultationNotAvailable = require("./assets/consultation-not-available.png");
export { consultationNotAvailable };

const loadingGif = require("./assets/hourglass.gif");
export { loadingGif };

export const supportIcon = require("./assets/support.png");

const width = Dimensions.get("window").width;
const height = Dimensions.get("window").height;

export { width, height };
